import { useInfiniteQuery } from '@tanstack/react-query';
import { getCharacters, CharacterSearchParams, CharactersResponse } from '../api/characters';

/**
 * Custom hook for character search
 * Uses TanStack Query for data fetching, caching, and pagination
 */
export const useCharacters = (searchParams: CharacterSearchParams = {}) => {
  // Default to online characters only
  const params = { 
    online: true, 
    ...searchParams 
  };
  
  // Use infinite query for pagination
  const query = useInfiniteQuery({
    queryKey: ['characters', params],
    queryFn: ({ pageParam = 1 }) => 
      getCharacters({ ...params, page: pageParam, size: 1000 }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, _, lastPageParam) => {
      // Check if there might be more pages
      // If we got a full page, there might be more
      return lastPage.characters.length === lastPage.size 
        ? lastPageParam + 1 
        : undefined;
    },
    staleTime: 30000, // 30 seconds
  });
  
  // Compute all characters by flattening pages
  const characters = query.data?.pages.flatMap(page => page.characters) ?? [];
  
  return {
    ...query,
    characters,
  };
}; 